import React from 'react';
import SectionHeader from '@monorepo/shared/src/components/layout/SectionHeader';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import { useParams } from 'react-router-dom';
import { WithFeatureToggle } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/FeatureToggles/WithFeatureToggle';
import { Box, Grid } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import findItObjectSrc from 'assets/images/find_it_pictures@6x.png';
import findItWordsSrc from 'assets/images/find_it_letters.png';
import soundOutWordsSrc from 'assets/images/read_it_words@6x.png';
import { AppRoutes } from 'types';
import ActivityLink from './components/ActivityLink';
import useTrialUserOmitRoutes from 'state/hooks/use-trial-user-omit-routes';

const t = (key: string, options?) => translate('letterBooks', key, options);

type Activity = {
  description: string;
  featureToggled?: boolean;
  featureToggleName?: string;
  route: string;
  src: string;
  title: string;
};

const SelectFindItActivities: React.FC = () => {
  const { letter } = useParams();
  const omitRoutes = useTrialUserOmitRoutes();
  const activities = [
    {
      description: t('findItWordsDescription'),
      route: `/${letter}/activities/FindTheLetter`,
      src: findItWordsSrc,
      title: t('findItWordsTitle'),
    },
    {
      description: t('findItObjectsDescription'),
      // featureToggled: true,
      // featureToggleName: 'findTheObjects',
      route: `/${letter}/activities/FindTheObjects`,
      src: findItObjectSrc,
      title: t('findItObjectsTitle'),
    },
    {
      description: t('soundOutWordsDescription'),
      route: `/${letter}/activities/SoundOutWords`,
      src: soundOutWordsSrc,
      title: t('soundOutWordsTitle'),
    },
  ];
  const classes = styles();
  return (
    <>
      <SectionHeader
        omitRoutes={omitRoutes}
        title={t('selectFindItActivity')}
        backRoute={`/${AppRoutes.LETTER_TEACHING}/${letter}/letter-books`}
      />
      <Box className={classes.box}>
        <Grid container spacing={6} className={classes.gridContainer}>
          {activities.map((activity: Activity) =>
            activity.featureToggled ? (
              <WithFeatureToggle key={activity.title} name={activity.featureToggleName as string}>
                <ActivityLink {...activity} letter={letter ?? ''} />
              </WithFeatureToggle>
            ) : (
              <ActivityLink key={activity.title} {...activity} letter={letter ?? ''} />
            )
          )}
        </Grid>
      </Box>
    </>
  );
};

const styles = makeStyles((theme: any) => ({
  box: {
    background: theme.palette.primary.contrastText,
    height: '-webkit-fill-available',
    [theme.breakpoints.up('lg')]: {
      height: 'calc(100vh - 60px)',
    },
  },
  gridContainer: {
    padding: `${theme.spacing(8)} ${theme.spacing(24)}`,
    overflow: 'hidden',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      padding: `${theme.spacing(8)} ${theme.spacing(10)}`,
      justifyContent: 'center',
    },
  },
}));

export default SelectFindItActivities;
